import Paper from "@mui/material/Paper";
import { SetStateAction, useEffect, useState } from "react";
import { Card, Grid, Typography, Divider, Box, CircularProgress } from "@mui/material";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import api from "../../../utils/Url";
import { useTranslation } from "react-i18next";
import ToastApp from "../../../ToastApp";
import { getISTDate, getdivisionId } from "../../../utils/Constant";
import "react-quill/dist/quill.snow.css";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { FaQuestionCircle } from 'react-icons/fa'; // Example for an icon

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  height: "80%",
  bgcolor: "#f5f5f5",
  border: "1px solid #2B4593", // Use a professional border color
  boxShadow: 10,
  p: 4,
  borderRadius: 10,
};

type Props = {};

export default function HelpDesk(props: Props) {
  const location = useLocation();
  const { i18n, t } = useTranslation();

  const [isLoading, setIsLoading] = useState(true);
  const [PageName, setPageName] = useState<any>("");
  const [PageDesk, setPageDesk] = useState<any>("");

  useEffect(() => {
    const menuData = localStorage.getItem("menuData");

    if (menuData) {
      getHelpDesk(menuData);
    } else {
      toast.error("No Menu Id is present. Please try again.......", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  }, []);

  const getHelpDesk = (id: any) => {
    const collectData = {
      pageTitleId: id,
    };
    api.post(`HelpCreation/GetHelpCreation`, collectData).then((res) => {
      const arr: any = [];
      for (let index = 0; index < res.data.data.length; index++) {
        setPageName(res.data.data[index]["page_Name"]);
        setPageDesk(res.data.data[index]["frontDesign"]);
      }
      setIsLoading(false);  // Set loading to false after data is fetched
    });
  };

  return (
    <>
      <Grid item lg={6} sm={6} xs={12} sx={{ marginTop: "3vh" }}>
        <ToastApp />
        <Card
          style={{
            width: "100%",
            backgroundColor: "#E9FDEE",
            border: ".5px solid #2B4593",
            borderRadius: "12px",  // Softened corners for a modern look
            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
            marginTop: "5px",
            padding: "20px",
          }}
        >
          <Paper
            sx={{
              width: "100%",
              overflow: "hidden",
            }}
            style={{ padding: "10px" }}
          >
            <ConfirmDialog />
            <Typography
              gutterBottom
              variant="h4"
              component="div"
              sx={{
                padding: "10px",
                fontWeight: "bold",
                textAlign: "center",
                color: "#2B4593", // Darker color for header
              }}
            >
              <FaQuestionCircle style={{ marginRight: "10px" }} />
              {t("text.HelpDesk")}
            </Typography>
            <Divider sx={{ marginBottom: "10px" }} />

            <Box height={10} />

            {isLoading ? (
              <Box sx={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
                <CircularProgress color="primary" />
              </Box>
            ) : PageName && PageDesk ? (
              <Grid item xs={12} container spacing={3}>
                <Grid xs={12} sm={4} item>
                  <Typography fontWeight="600" fontSize={20} sx={{ color: "#2B4593" }}>
                    Page Name :- <i>{PageName}</i>
                  </Typography>
                </Grid>

                <Grid item sm={12} md={12}>
                  <Typography
                    id="modal-modal-title"
                    variant="h6"
                    component="h2"
                    sx={{ fontSize: "18px", color: "#555" }}
                  >
                    Content :-{" "}
                    <span dangerouslySetInnerHTML={{ __html: PageDesk }} />
                  </Typography>
                </Grid>
              </Grid>
            ) : (
              <Typography fontWeight="530" fontSize={30} color="gray">
                No content available.
              </Typography>
            )}
          </Paper>
        </Card>
      </Grid>
      <ToastApp />
    </>
  );
}
